module.exports = __webpack_public_path__ + "img/26.9bd93f7b.png";